import TemplatesList from "./TemplatesList";
import TemplateCRU from "./TemplateCRU";
import EngineModuleCRU from "./EngineModuleCRU";
import EngineModuleList from "./EngineModuleList";
export {
    TemplatesList,
    TemplateCRU,
    EngineModuleCRU,
    EngineModuleList
}

export const templateObj = {
    engine_family: null,
    section_id: '',
    remarks: '',
    active: false,
    file: []
}
export const engModuleObj = {
    engine_family: null,
    remarks: '',
    active: false,
    file: []
}

export const template_Filter = {
    'engine_family': {
        'inputType': 'dropdown',
        'title': 'Engine Family',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': true
    },
    'section_id': {
        'inputType': 'dropdown',
        'title': 'Section',
        'options': [{ id: 4, name: 'AD STATUS' }, { id: 5, name: 'SB STATUS' },{ id: 8, name: 'LLP STATUS' }, { id: 10, name: 'INVENTORY LIST' },{ id: 12, name: 'SOFT TIME' },{ id: 16, name: 'MASTER COMPONENTS' },],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': false
    },
    'active': {
        'inputType': 'dropdown',
        'title': 'Active',
        'options': [{ id: "true", name: 'YES' }, { id: "false", name: 'NO' }],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': false
    },
    'created_by': {
        'inputType': 'dropdown',
        'title': 'Created By',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': false
    },
    'updated_by': {
        'inputType': 'dropdown',
        'title': 'Modified By',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': false
    },
};